module.exports = __webpack_public_path__ + "static/media/8x10.e979c68b.png";